const ID_SUFFIX = 'appsflyer-sdk-';

// HACK: NAVI-5275
const createStyle = (head: HTMLHeadElement, id: string) => {
  if (document.getElementById(id)) {
    return;
  }

  const style = document.createElement('style');
  style.id = id;

  style.innerHTML = `[data-af-custom-fonts="af-creatives-text"]{font-family: LMMain, Roboto, apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, sans-serif !important}span[data-af-custom-fonts="af-creatives-text"]{font-weight: 600 !important}`;
  head.appendChild(style);
};

const createScript = (head: HTMLHeadElement, id: string, apiKey: string, zIndex: number) => {
  if (document.getElementById(id)) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.id = id;

  script.innerHTML = `
      !function(t, e, n, s, a, c, i, o, p) {
        t.AppsFlyerSdkObject = a, t.AF = t.AF || function() {
          (t.AF.q = t.AF.q || []).push([Date.now()].concat(Array.prototype.slice.call(arguments)))
        }, t.AF.id = t.AF.id || i, t.AF.plugins = {}, o = e.createElement(n), p = e.getElementsByTagName(n)[0], o.async = 1, o.src = "https://websdk.appsflyer.com?" + (c.length > 0 ? "st=" + c.split(",").sort().join(",") + "&" : "") + (i.length > 0 ? "af_id=" + i : ""), p.parentNode.insertBefore(o, p)
      }(window, document, "script", 0, "AF", "banners", {
        banners: {
          key: "${apiKey}"
        }
      });
      AF('banners', 'showBanner', { bannerZIndex: ${zIndex} })
    `;
  head.appendChild(script);
};

export const addAppsflyerScript = (apiKey: string, zIndex: number) => {
  const { head } = document;

  if (head) {
    createStyle(head, ID_SUFFIX + 'style');
    createScript(head, ID_SUFFIX + 'script', apiKey, zIndex);
  }
};
